import { DOMExportOutput, LexicalEditor, LexicalNode, ParagraphNode } from 'lexical';
import { constructExportMap } from '../constructExportMap';

function appendStyle(element: HTMLElement, style: string)
{
    const current = element.getAttribute('style');
    element.setAttribute('style', current ? `${current}; ${style}` : style);
}

export function constructRawHtmlExportMap()
{
    const map = constructExportMap();

    map.set(ParagraphNode as any, (editor: LexicalEditor, node: LexicalNode) =>
    {
        const out = (node as any).exportDOM(editor) as DOMExportOutput;
        const el = out.element;

        if (el instanceof HTMLElement)
        {
            const parentType = node.getParent()?.getType();
            const isTableCell = parentType === 'tablecell' || parentType === 'raw-html-table-cell';

            if (isTableCell)
            {
                appendStyle(el, 'margin: 0; padding: 0');
            }
        }

        return out;
    });

    return map;
}